import { Box, Paper, styled } from "@mui/material";

export const SAnalyticsCookieBanner = styled(Paper)(({ theme }) => ({
  position: "fixed",
  left: 0,
  bottom: 0,
  width: "100%",
  zIndex: 100,
  background: theme.palette.background.paper,
  padding: theme.spacing(1, 2, 2, 2),
  display: "flex",
  flexDirection: "column",
  "& p": {
    fontSize: "12px",
  },
  "& a": {
    display: "block",
    color: "#026670",
  },
  [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
    padding: theme.spacing(6, 3, 3, 3),
    "& p": {
      fontSize: "14px",
    },
  },
}));

export const SAnalyticsAgreementButtonWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  justifyContent: "space-around",
  width: "100%",
}));
